/**
 * @file Album Folder Tag Search Reducer.
 */

import { UPDATE_FILTER } from '../actions/album-folder-tag-search';
import { ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE } from '../constants/album-folder-tags';

export const initialState = {
  tagIds: [],
  // Using this to reset the search query
  // Whenever the entityId gets changed.
  // This will avoid searching for tags that are
  // not part of the entity (be it album or albumFolder.)
  entityId: '',
  filterMode: ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE.ANY,
};

const albumFolderTagSearchReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        tagIds: action.filter,
        entityId: action.entityId,
        filterMode:
          action.filterMode || ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE.ANY,
      };

    default:
      return state;
  }
};

export default albumFolderTagSearchReducer;
